import { useTranslation } from 'next-i18next';
import styled from 'styled-components';
import CircularLoading from '../ui/CircularLoading';
import { logEvent } from '../../new-lib/analytics';
import { getPageLocation } from '../../helpers/common';
import { useRouter } from 'next/router';

interface loadMorePresentationProps {
  loadedDataLength: number;
  limit: number;
  isLoading: boolean;
  handleLoadMore: () => void;
}
const LoadMorePresentation = ({
  loadedDataLength,
  limit,
  handleLoadMore,
  isLoading
}: loadMorePresentationProps) => {
  const { t } = useTranslation('common');
  const { asPath } = useRouter();
  const handleClick = () => {
    if (asPath.startsWith('/new-launches')) {
      logEvent.click('lnch_load_more', getPageLocation(asPath), 'launches');
    }
  };

  return loadedDataLength < limit ? (
    <Container className="load-more" onClick={handleClick}>
      <button onClick={handleLoadMore} disabled={isLoading}>
        {isLoading ? (
          <CircularLoading width="20px" height="20px" />
        ) : (
          <span>{t('load_more')}</span>
        )}
      </button>
    </Container>
  ) : null;
};

const Container = styled.div`
  width: 100%;

  button {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 45px;
    padding: 0 16px;
    background-color: #fff;
    border-radius: 10px;
    border: 1px solid #015c9a;
    font-family: materialSemiBold;
    font-size: ${props => props.theme.font.sizes.xs};
    color: #015c9a;
    margin-bottom: 16px;

    div {
      border: 3px solid #015c9a !important;
      border-top: 3px solid transparent !important;
    }
  }
`;

export default LoadMorePresentation;
